"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _formItem = _interopRequireDefault(require("./form-item"));
var _log = require("../../tools/log");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  name: 'VxeFormGather',
  extends: _formItem.default,
  provide: function provide() {
    return {
      $xeformgather: this,
      xeformitem: null,
      $xeformiteminfo: this
    };
  },
  created: function created() {
    var _this = this;
    if (process.env.NODE_ENV === 'development') {
      this.$nextTick(function () {
        if (_this.$xeform && _this.$xeform.customLayout) {
          (0, _log.errLog)('vxe.error.errConflicts', ['custom-layout', '<form-gather ...>']);
        }
      });
    }
  },
  render: function render(h) {
    return h('div', this.$slots.default);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/form/src/form-gather.js
// module id = 978
// module chunks = 75